import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { cartReducer, formReducer } from './reducers';

const reducer = combineReducers({
  cart: cartReducer,
  form: formReducer,
});

const middlewares = [thunk];

if (process.env.NODE_ENV !== 'production') {
  // Redux logger MUST BE the last middleware
  const { logger } = require('redux-logger');
  middlewares.push(logger);
}

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const getStore = (preloadedState = {}) =>
  createStore(
    reducer,
    preloadedState,
    composeEnhancers(applyMiddleware(...middlewares))
  );

export default getStore;
